import { Button, Card, Col } from 'antd';
import React, { PureComponent } from 'react';
import injectSheet from 'react-jss';
import background from '../../../assets/background.jpg';
import paulineAvatar from '../../../assets/Pauline.png';
import Competences from './components/Competences';
import Presentation from './components/Presentation';

const styles = () => ({
  root: {
    width: '100%',
  },
  topBackground: {
    backgroundSize: 'cover',
    width: '100%',
    minHeight: '600px',
    padding: '2em 0',
    backgroundImage: (props) => `url(${background})`,
  },
  card: {
    backgroundColor: 'rgba(0,0,0,0.72)',
    padding: '20px',
    paddingLeft: 'calc(12.5vw - 24px)',
  },
  cardBody: {
    paddingLeft: 0,
  },
  cardText: {
    color: '#FFFFFF',
    fontSize: '1.2rem',
    paddingBottom: '1em',
    lineHeight: '2em',
  },
  title2: {
    opacity: 0,
    animation: 'fadeIn ease-in 1',
    animationFillMode: 'forwards',
    animationDuration: '3s',
    animationDelay: '0.5s',
  },
  title3: {
    opacity: 0,
    animation: 'fadeIn ease-in 1',
    animationFillMode: 'forwards',
    animationDuration: '3s',
    animationDelay: '2.5s',
  },
  button: {
    float: 'right',
    opacity: 0,
    animation: 'fadeIn ease-in 1',
    animationFillMode: 'forwards',
    animationDuration: '2s',
    animationDelay: '4s',
  },
});

class Home extends PureComponent {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.topBackground}>
          <Col md={12} xs={24}>
            <Card bordered={false} className={classes.card}>
              <div className={classes.cardText}>
                <p>Maître Pauline Laborie</p>
                <p className={classes.title2}>Avocat en droit public</p>
                <p className={classes.title3}>
                  Tribunal administratif et cour administrative
                </p>
              </div>

              <div className={classes.button}>
                <Button type="primary">
                  <a href="#presentationPauline">En savoir plus</a>
                </Button>
              </div>
            </Card>
          </Col>
        </div>

        <Presentation
          id="presentationPauline"
          title="Maître Pauline Laborie"
          img={paulineAvatar}
          text="Me Pauline LABORIE, avocat à la cour, dispose d’un cabinet situé au centre ville de Grenoble.
Elle intervient devant les tribunaux administratifs ainsi que devant les cours administratives d’appel pour l’ensemble des contentieux ayant trait au droit administratif.
Titulaire d’un master II, « Droit, administration publique et territoire » elle possède également une expérience de deux années au sein du tribunal administratif de Grenoble comme assistante de justice.
"
          backgroundColor=""
          imgStyle=""
        />
        <Competences />
      </div>
    );
  }
}

const HomeStyled = injectSheet(styles)(Home);

export default HomeStyled;



// WEBPACK FOOTER //
// ./src/app/pages/home/index.jsx